export default __webpack_public_path__ + "static/media/Shopify_Autopilot.392ba57c.mp4";